import { addAriaLiveLabel } from 'mini-accessibility';
import { RsvpServiceState } from 'mini-rsvp/lib/schema/RsvpServiceState';
/**
 * @returns a function which executes input callback and adds ariaLiveLabel to aria-live region when service succeeds
 * @param callback to be executed when service succeeds
 * @param ariaLiveLabel to be announced to a11y users when service succeeds
 */
export const getOnSuccessCallback = (callback?: (...args: any) => void, ariaLiveLabel?: string) => (
    rsvpServiceState: RsvpServiceState,
    ...args: any[]
) => {
    if (rsvpServiceState === RsvpServiceState.Success) {
        callback?.(...args);
        ariaLiveLabel && addAriaLiveLabel(ariaLiveLabel, 'assertive');
    }
};
